import { Link } from "react-router-dom";
import { KeyRound } from "lucide-react";
import { Logo } from "./Logo";

export const Footer = () => (
  <footer className="border-t border-trace-line bg-trace-panel" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-[1.4fr_1fr_1fr] lg:px-8">
      <div className="space-y-4">
        <Logo testId="footer-logo" />
        <p className="max-w-sm text-sm leading-relaxed text-trace-muted">
          Don't trust the token. Trace it. Solana token transparency and wallet intelligence.
        </p>
        <p className="flex max-w-sm items-start gap-2 rounded-lg border border-trace-line bg-trace-card p-3 text-xs text-trace-muted" data-testid="footer-security-note">
          <KeyRound size={14} className="mt-0.5 shrink-0 text-trace-green" />
          TRACE will never ask for your seed phrase, private keys or a wallet connection to scan a token.
        </p>
      </div>
      <div className="space-y-3 text-sm">
        <p className="eyebrow">Product</p>
        <Link to="/scan" className="block text-trace-muted hover:text-white" data-testid="footer-scanner-link">Token scanner</Link>
        <Link to="/scan/demo" className="block text-trace-muted hover:text-white" data-testid="footer-demo-link">Demo report</Link>
        <Link to="/developers" className="block text-trace-muted hover:text-white" data-testid="footer-api-link">Developer API (planned)</Link>
      </div>
      <div className="space-y-3 text-sm">
        <p className="eyebrow">Company</p>
        <Link to="/#about" className="block text-trace-muted hover:text-white" data-testid="footer-about-link">About</Link>
        <Link to="/#token" className="block text-trace-muted hover:text-white" data-testid="footer-token-link">$TRACE</Link>
      </div>
    </div>
    <div className="border-t border-trace-line">
      <p className="mx-auto max-w-7xl px-4 py-6 text-xs leading-relaxed text-trace-dim sm:px-6 lg:px-8">
        © {new Date().getFullYear()} TRACE. Information is provided for research purposes only and is not financial advice.
        Risk indicators describe observable patterns and never guarantee that a token is safe.
      </p>
    </div>
  </footer>
);
